import React, { useMemo } from 'react';
import { useLocation } from 'react-router';
import FormSection from 'components/shared/FormSection';
import RecruitmentInfoEn from './RecruitmentInfoEn';
import JobDescriptionEn from './JobDescriptionEn';
import JobRequirementsEn from './JobRequirementsEn';
import JobApplicationProfileEn from './JobApplicationProfileEn';
import JobBenefitsEn from './JobBenefitsEn';

function RecruitmentEnTab() {
  const { pathname } = useLocation();
  const disabled = useMemo(() => pathname.includes('/detail'), [pathname]);

  const detailForm = [
    {
      title: 'Thông tin tuyển dụng (tiếng anh)',
      component: RecruitmentInfoEn,
      fieldActive: ['recruitment_name_en', 'introduction_en'],
    },
    {
      title: 'Mô tả công việc (tiếng anh)',
      component: JobDescriptionEn,
      fieldActive: ['job_description_en'],
    },
    {
      title: 'Yêu cầu công việc (tiếng anh)',
      component: JobRequirementsEn,
      fieldActive: ['requirements_en'],
    },
    {
      title: 'Quyền lợi (tiếng anh)',
      component: JobBenefitsEn,
      fieldActive: ['benefits_en'],
    },
    {
      title: 'Hồ sơ ứng tuyển (tiếng anh)',
      component: JobApplicationProfileEn,
      fieldActive: ['request_profile_en'],
    },
  ];

  return <FormSection loading={false} detailForm={detailForm} disabled={disabled} />;
}

export default RecruitmentEnTab;
